import type { ComponentType } from 'react'
import type { SiteDocDetail, SiteDocKind } from '@symphenia/shared-types'

export interface ErpVorzeigeProps {
  /** Fachteil des kanonischen Stands — gezeichnet wird aus ihm, nicht aus dem Formular (AP-46 9.). */
  fachteil: Record<string, unknown>
}

/**
 * AP-46 5.4 — **Das Register der Arten im ERP**: was eine Art im Rahmen zeigt. Der Rahmen kennt keine
 * Art; der Regiebericht meldet sich mit AP-27 an. Ohne Eintrag zeigt die Vorzeige den Fachteil als
 * schlichte Liste (`FachteilListe`).
 */
export interface ErpDetailProps {
  dok: SiteDocDetail
  /** Nach einer Änderung: das neue Detail, sonst lädt die Seite neu. */
  onGeaendert: (neu?: SiteDocDetail) => void
}

export interface ErpEinstellungenProps {
  /** `extra` der Einstellungen der Art (beim Regiebericht Zeilenarten und Zuschlagsliste). */
  extra: Record<string, unknown> | null
  /** Schreibt `extra` als Ganzes — über die Speicherstelle der Einstellungen (AP-36 8.3 a). */
  speichere: (extra: Record<string, unknown>) => Promise<unknown>
}

/** AP-49 — Angaben der Art im Anlegedialog (Besprechung: die Besprechungsart, aus der die Serie wird). */
export interface ErpAnlegenWert {
  /** Fachinhalt fürs Anlegen — `null`, solange die Angabe fehlt. */
  content: Record<string, unknown> | null
  /** Den Titel setzt der Server (Besprechung: „Baubesprechung Nr. 7") — das Feld entfällt im Dialog. */
  titelAutomatisch: boolean
}

export interface ErpAnlegenProps {
  onWert: (w: ErpAnlegenWert) => void
}

export interface ErpArt {
  kind: SiteDocKind
  Vorzeige: ComponentType<ErpVorzeigeProps>
  /** Eigene Einstellungen der Art unter denen des Rahmens. */
  Einstellungen?: ComponentType<ErpEinstellungenProps>
  /** Fachteil im Detailrahmen — im Entwurf bearbeitbar (AP-36), danach lesend. Fehlt er, zeigt der Rahmen den Inhalt als Liste. */
  Detail?: ComponentType<ErpDetailProps>
  /** Überschrift des Detailteils nach dem Abschluss (i18n-Schlüssel); ohne sie „Zuordnungen und Abrechnung". */
  detailTitel?: string
  /** Eigene Felder im Anlegedialog (AP-36 Fall 2 — nur, was zum Anlegen nötig ist). */
  Anlegen?: ComponentType<ErpAnlegenProps>
}

const arten = new Map<SiteDocKind, ErpArt>()

export function registriereErpArt(a: ErpArt): void {
  arten.set(a.kind, a)
}

export function erpArt(kind: SiteDocKind): ErpArt | null {
  return arten.get(kind) ?? null
}
